import React from 'react';
import HomePaigeContainer from 'containers/HomePaigeContainer';
import './styles.scss';

const HomePage = () => {
  return <HomePaigeContainer />;
};

export default HomePage;
